import React from 'react';
import { Link } from 'react-router-dom';
import logo from '../../assets/img/android-chrome-192x192.png';
import { HeaderNavLogoProps } from '../interfaces';
import './HeaderNavLogo.scss';

const HeaderNavLogo: React.FC<HeaderNavLogoProps> = ({ isActive }) => (
  <Link
    to="/"
    className={`header-nav__logo ${isActive ? 'is-active' : ''}`}
    aria-label="Home"
  >
    <img src={logo} alt="logo" className="nav-logo" />
  </Link>
);

export default HeaderNavLogo;
